<template>
  <div>
    <SiteHeader />
    <div class="page flex-col">
      <img
        class="image_1"
        referrerpolicy="no-referrer"
        src="./assets/img/SketchPnge6526ecb2fcab0802b546f04824fe8f83db80e06fef6b8cf3b08d187c494f182.png"
      />
      <div class="section_1 flex-col">
      <div class="box_3 flex-col">
        <div class="section_3 flex-row">
          <div class="text-group_1 flex-col">
            <span class="text_13">学科与科研</span>
            <span class="paragraph_1">
              （文案占位非正式内容）中国社会科学院新闻与传播研究所（原名『中国社会科学院新闻研究所』）成立于中国改革开放扬帆起航的&nbsp;1978&nbsp;年。
              <br />
              成立迄今，新闻与传播研究所已走过了卌载春秋，其原初的研究所名称、科室设置、职岗编制、&nbsp;内设中心乃至研究生教育的管理机制均有与时俱进的调整，不断优化与完善。
            </span>
          </div>
        </div>
        <div class="text-wrapper_3">
          <span class="text_14">
            <router-link to="/lanhu_shouye" style="color: inherit; text-decoration: none;">首页</router-link>
            &nbsp;&gt;&nbsp;
            <router-link to="/lanhu_xuekeyukeyan" style="color: inherit; text-decoration: none;">学科与科研</router-link>
            &nbsp;&gt;&nbsp;
          </span>
          <span class="text_15">学科建设</span>
        </div>
        <div class="section_4 flex-col"></div>
        <div class="section_6 flex-row justify-between">
          <SidebarAccordion
            :sections="sidebarSections"
            active-section-id="discipline"
            active-item-id="discipline-build"
          />
          <span class="paragraph_4">
            根据党中央的意见，组建新闻研究所的首要任务是研究整理中国共产党各个历史时期关于新闻工作的一系列指示和政策，因此马克思主义新闻学、党报理论与党报史是新闻所早期学科建设的重点，产出了一批高质量的研究成果，如，三卷本《中国共产党新闻工作文件汇编》、《新华日报史：&nbsp;1938—1947》、《延安〈解放日报〉史》等。随着改革开放的深入，新闻研究所与时俱进，引进或开拓了一系列新的研
            <br />
            究领域，如传播学、公共关系学、舆论学、受众调查、新闻法治、传媒经营管理、传播与社会发展、新媒体研究等。实施创新工程后，新闻与传播研究所在学科建设上确立了『稳定现有建制，强化优势学科，充实薄弱学科，适当扩充新学科』的发展策略，夯实学科基础，守正出新。2016&nbsp;年，中国社会科学院实施扶持优势学科和重点学科建设的『登峰计划』。新闻与传播研究所『新媒体研究』被列入『登峰计划』优势学科，『马克思主义新闻学』和『跨文化传播研究』被列入『登峰计划』重点学科。
          </span>
        </div>
        <SecondaryBottom
          variant="gallery"
          :config="bottomConfig"
        />
      </div>
    </div>
    <SiteFooter
      :notch-width="704"
      notch-left="calc((100vw - 1300px) / 2 + 445px)"
    />
  </div>
</div>
</template>
<script>
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/SiteFooter.vue';
import SidebarAccordion from '@/components/SidebarAccordion.vue';
import SecondaryBottom from '@/components/SecondaryBottom.vue';
import { createSidebarSections } from '@/config/secondarySidebar';

import bottomBannerImage from './assets/img/SketchPng4993a309a729988e6a9a29081fc05c054d6748bc46d90d2b3b5d819abf79bad0.png';
import bottomListIcon from './assets/img/SketchPng37f72464ab101f1fca5def67d705a7cec83844a5e9012f5833a9b54f3bde1ad5.png';

export default {
  components: {
    SiteHeader,
    SiteFooter,
    SidebarAccordion,
    SecondaryBottom
  },
  data() {
    return {
      sidebarSections: createSidebarSections({
        activeSectionId: 'discipline',
        activeItemId: 'discipline-build'
      }),
      bottomConfig: {
        title: '珍贵历史图片资料',
        bannerImage: bottomBannerImage,
        leftColumn: {
          primaryList:
            '<a href="#/lanhu_zhengwenyexueshuchengguo" style="color: inherit; text-decoration: none;">学术成果掠影</a><br /><br /><br /><a href="#/lanhu_zhongguochuanboxuedahui" style="color: inherit; text-decoration: none;">中国传播学大会</a><br /><br /><br /><a href="#/lanhu_xinmeitilanpishu" style="color: inherit; text-decoration: none;">新媒体蓝皮书发布暨新媒体发展研讨会</a><br /><br /><br /><a href="#/lanhu_yuqingdiaocha" style="color: inherit; text-decoration: none;">舆情调查</a><br /><br /><br /><a href="#/lanhu_xueshushalong" style="color: inherit; text-decoration: none;">学术沙龙活动</a><br /><br /><br /><a href="#/lanhu_yanjiuzhongxin" style="color: inherit; text-decoration: none;">研究中心活动</a><br /><br /><br /><a href="#/lanhu_xueshupingjia" style="color: inherit; text-decoration: none;">学术评价</a>',
          middleIcon: bottomListIcon,
          secondaryList:
            '<a href="#/lanhu_keyanchengguohuojiang" style="color: inherit; text-decoration: none;">新闻与传播研究所科研成果获奖情况</a><br /><br /><br /><a href="#/lanhu_shouzhongyanjiu" style="color: inherit; text-decoration: none;">受众研究学术研讨会</a><br /><br /><br /><a href="#/lanhu_xinwenshiqingnian" style="color: inherit; text-decoration: none;">新闻史青年学者论坛</a><br /><br /><br /><a href="#/lanhu_guoneixueshujiaoliu" style="color: inherit; text-decoration: none;">国内学术交流</a><br /><br /><br /><a href="#/lanhu_diaoyanhuodong" style="color: inherit; text-decoration: none;">调研活动</a><br /><br /><br /><a href="#/lanhu_guojixueshujiaoliu" style="color: inherit; text-decoration: none;">国际学术交流</a>'
        },
        timelineIcons: [
          {
            wrapperClass: 'image-wrapper_3 flex-row',
            icons: [{ className: 'thumbnail_9', src: bottomListIcon }]
          },
          {
            wrapperClass: 'image-wrapper_4 flex-row',
            icons: [{ className: 'thumbnail_10', src: bottomListIcon }]
          },
          {
            wrapperClass: 'image-wrapper_5 flex-row',
            icons: [{ className: 'thumbnail_11', src: bottomListIcon }]
          },
          {
            wrapperClass: 'image-wrapper_6 flex-row',
            icons: [{ className: 'thumbnail_12', src: bottomListIcon }]
          },
          {
            wrapperClass: 'image-wrapper_7 flex-row justify-between',
            icons: [
              { className: 'thumbnail_13', src: bottomListIcon },
              { className: 'thumbnail_14', src: bottomListIcon }
            ]
          },
          {
            wrapperClass: 'image-wrapper_8 flex-row justify-between',
            icons: [
              { className: 'thumbnail_15', src: bottomListIcon },
              { className: 'thumbnail_16', src: bottomListIcon }
            ]
          },
          {
            wrapperClass: 'image-wrapper_9 flex-row justify-between',
            icons: [
              { className: 'thumbnail_17', src: bottomListIcon },
              { className: 'thumbnail_18', src: bottomListIcon }
            ]
          }
        ],
        rightColumnImage: bottomListIcon
      },
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />
